import { render, staticRenderFns } from "./markdown.vue?vue&type=template&id=84cc88ae"
import script from "./markdown.vue?vue&type=script&lang=js"
export * from "./markdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84cc88ae')) {
      api.createRecord('84cc88ae', component.options)
    } else {
      api.reload('84cc88ae', component.options)
    }
    module.hot.accept("./markdown.vue?vue&type=template&id=84cc88ae", function () {
      api.rerender('84cc88ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/markdown-view-renderer/markdown.vue"
export default component.exports